import React from 'react'
import ProgressCard from '../../../../../common/card/ProgressCard'
import BarHorizontal from '../../../../../common/chart/BarHorizontal'
import { useCourseReport } from '../../../ReportingGroup/context/CourseReportContext'

const CourseStats = () => {
    const { selectedCourse } = useCourseReport()

    const enrolledCount = selectedCourse.enrolled
    const courseStats = [
        {
            'title': 'Enrolled', 
            'value': selectedCourse.enrolled ?? 0,
        },
        {
            'title': 'Completed', 
            'percentage': Math.round((selectedCourse.completed / enrolledCount) * 100),
            'value': selectedCourse.completed ?? 0,
            'theme': 'success',
        },
        {
            'title': 'In Progress', 
            'percentage': Math.round((selectedCourse.inProgress / enrolledCount) * 100),
            'value': selectedCourse.inProgress ?? 0,
            'theme': 'warning',
        },
        {
            'title': 'Not Started', 
            'percentage': Math.round((selectedCourse.notStarted / enrolledCount) * 100),
            'value': selectedCourse.notStarted ?? 0,
            'theme': 'secondary',
        }
    ]

    return (
        <div className="msync-reporting__detail__overview">
            <h3 className="msync-reporting__detail__overview__title">Course Stats</h3>
            <div className="msync-reporting__detail__overview__content">
                <div className="msync-reporting__detail__overview__part msync-course-status-container">
                    <BarHorizontal courseStats={courseStats} />
                    {
                        courseStats.map((content, key) => (
                            <ProgressCard key={key} content={content}/>
                        ))
                    }
                </div>
            </div>
        </div>
    )
}

export default CourseStats